import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsCardOnboardingUploadDocsClickUploadId,
    analyticsCardOnboardingUploadDocsClickUploadAddress,
    analyticsCardOnboardingUploadDocsClickSubmit,
} from '@perpay-web/fintech/actions/analytics/perpayCreditCardOnboarding';
import CardUploadDocuments from '@perpay-web/fintech/components/composite/CardUploadDocuments/CardUploadDocuments';
import {
    getIsProofOfIdRequested,
    getIsProofOfAddressRequested,
} from '@perpay-web/fintech/dataModules/crud/cardAccountApplication';
import { uploadCardDocumentsDataModule } from '@perpay-web/fintech/dataModules/uploadCardDocuments';
import { paths } from '@perpay-web/fintech/props/appPaths';

const CardUploadDocumentsContainer = ({ isPHO = false }) => {
    const dispatch = useDispatch();
    const isSubmitting = useSelector(
        uploadCardDocumentsDataModule.getIsLoading,
    );
    const errors = useSelector(uploadCardDocumentsDataModule.getErrors);
    const isProofOfIdRequested = useSelector(getIsProofOfIdRequested);
    const isProofOfAddressRequested = useSelector(getIsProofOfAddressRequested);

    const analyticsOnClickUploadPhotoId = () => {
        dispatch(analyticsCardOnboardingUploadDocsClickUploadId());
    };

    const analyticsOnClickUploadProofOfAddress = () => {
        dispatch(analyticsCardOnboardingUploadDocsClickUploadAddress());
    };

    const onClickSubmit = (payload) => {
        dispatch(analyticsCardOnboardingUploadDocsClickSubmit());
        dispatch(uploadCardDocumentsDataModule.dataRequest(payload));
    };

    const dashboardURL = isPHO
        ? `${paths.dashboard.path}?PHO_complete=true`
        : paths.dashboard.path;

    return (
        <CardUploadDocuments
            errors={errors}
            isSubmitting={isSubmitting}
            isProofOfIdRequested={isProofOfIdRequested}
            isProofOfAddressRequested={isProofOfAddressRequested}
            analyticsOnClickUploadPhotoId={analyticsOnClickUploadPhotoId}
            analyticsOnClickUploadProofOfAddress={
                analyticsOnClickUploadProofOfAddress
            }
            onClickSubmit={onClickSubmit}
            dashboardURL={dashboardURL}
        />
    );
};

export default CardUploadDocumentsContainer;
